<template>
  <main>
    <PageIntro :heading="'Reset your <span>' + configStrings.productName + ' password</span>'"
      :body="'<p>To change your password, simply click the password reset link in the email we\'ve just sent you.</p>'" />
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3>

          <v-layout row align-center mx-1>
            <router-link to="/forgot-password" class="text-button">Resend password reset link</router-link>
            <v-spacer />
          </v-layout>
        </v-flex></v-layout></v-container>
    <FooterShout :type="'signin'" />
  </main>
</template>

<script>
import PageIntro from '@/components/PageIntro'
import FooterShout from '@/components/FooterShout'

export default {
  components: {
    PageIntro,
    FooterShout
  }
}
</script>